"use client";

import React from "react";
import { Facebook, Globe, Instagram, Linkedin, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-secondary-foreground/10 rounded animate-pulse" />
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-secondary-foreground/80 hover:text-primary transition-colors">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const socialLinks = [{
    icon: Mail,
    href: "mailto:Info-TMBau@web.de",
    label: "E‑Mail"
  }, {
    icon: Globe,
    href: "https://tm-bauservices.de",
    label: "Website"
  }, {
    icon: Facebook,
    href: "https://www.facebook.com/deinprofil",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "https://www.instagram.com/deinprofil",
    label: "Instagram"
  }, {
    icon: Linkedin,
    href: "https://www.linkedin.com/in/deinprofil",
    label: "LinkedIn"
  }];
  return <section id="footer" className="bg-secondary text-secondary-foreground py-12 lg:py-16">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-12">
          
          {}
          <div className="space-y-6">
            <Link to="/">
              
            </Link>
            
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-lg font-semibold tracking-tight">Navigation</h3>
            <MenuProvider menu_id="39">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-lg font-semibold tracking-tight">Kontakt</h3>
            <ul className="space-y-4 text-sm text-secondary-foreground/80">
              <li className="flex items-start gap-3">
                <MapPin className="size-5 shrink-0 text-primary" />
                <span>Gymnasialstraße 2, 55543 Bad Kreuznach</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="size-5 shrink-0 text-primary" />
                <Link to="tel:+491791505044" className="hover:text-primary transition-colors">+49 1791505044</Link>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="size-5 shrink-0 text-primary" />
                <Link to="mailto:Info-TMBau@web.de" className="hover:text-primary transition-colors">Info-TMBau@web.de</Link>
              </li>
            </ul>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-lg font-semibold tracking-tight">Netzwerke</h3>
            <div className="flex items-center gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              const isExternal = social.href.startsWith("http");
              return <Link key={i} data-index={i} to={social.href} newTab={isExternal} rel={isExternal ? "noopener noreferrer" : undefined} className="flex size-10 items-center justify-center rounded-full bg-secondary-foreground/5 text-secondary-foreground hover:bg-primary hover:text-primary-foreground transition-all duration-300" aria-label={social.label}>
                    <Icon className="size-5" />
                  </Link>;
            })}
            </div>
            <div className="pt-2">
              <Badge variant="default" className="bg-primary text-primary-foreground hover:bg-primary/90 px-3 py-1 text-sm">
                Regionaler Partner
              </Badge>
            </div>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-lg font-semibold tracking-tight">Cookie‑Richtlinie</h3>
            <div className="space-y-3 text-sm text-secondary-foreground/80">
              <p>
                Wir verwenden Cookies, um die Funktionalität unserer Website zu gewährleisten und Ihr Nutzererlebnis zu optimieren.
              </p>
              <Link to="/DataProtectionPage" className="text-primary hover:text-primary/80 transition-colors font-medium">
                Details anzeigen
              </Link>
            </div>
          </div>
        </div>

        {}
        <Separator className="my-10 bg-secondary-foreground/10" />
        
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-secondary-foreground/60">
          <p>&copy; {new Date().getFullYear()} BauPartner. Alle Rechte vorbehalten.</p>
          <div className="flex items-center gap-3">
            <Link to="/TermsAndConditionsPage" className="hover:text-primary transition-colors">
              AGB
            </Link>
            <span className="text-secondary-foreground/30">|</span>
            
            <span className="text-secondary-foreground/30">|</span>
            <Link to="/LegalNoticePage" className="hover:text-primary transition-colors">
              Impressum
            </Link>
          </div>
        </div>
      </div>
    </section>;
}